export default __webpack_public_path__ + "static/media/pido.5597a9e2.png";